import { AfterViewInit, ElementRef, Input, OnDestroy, QueryList, SimpleChanges, ViewChildren, Directive } from "@angular/core";
import { NgControl } from "@angular/forms";
import { BaseLinkedCollection } from '../../../../modules/tcm-core.module';
import { Subscription } from "rxjs";
import { ActionButtonDirective } from "../../directives/action-button.directive";
import { FormControlBase } from "../../../../modules/tcm-form/common/form-control-base/form-control-base";

@Directive()
export abstract class BaseSecureLinkedCollection<TCollectionRecord extends {}> extends BaseLinkedCollection<TCollectionRecord> implements AfterViewInit, OnDestroy {

  @Input()
  public editable: boolean;

  @ViewChildren(NgControl)
  private controls: QueryList<NgControl>;

  @ViewChildren(ActionButtonDirective)
  private buttons: QueryList<ActionButtonDirective>;

  private controlsSubscription: Subscription;
  private buttonsSubscription: Subscription;

  constructor() {
    super();
  }

  override ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (changes.editable) {
      this.allowDelete = this.editable;
      this.setupControlsState();
      this.setupActionButtonsState();
    }
  }

  ngAfterViewInit() {
    this.controlsSubscription = this.controls.changes.subscribe(() => { this.setupControlsState(); });
    this.buttonsSubscription = this.buttons.changes.subscribe(() => this.setupActionButtonsState());
  }

  ngOnDestroy() {
    this.controlsSubscription.unsubscribe();
    this.buttonsSubscription.unsubscribe();
  }

  private setupControlsState() {
    setTimeout(() => {
      const wafFormControls = this.controls
        .filter(x => x.valueAccessor instanceof FormControlBase)
        .map(x => x.valueAccessor as FormControlBase<any>);

      wafFormControls.forEach(x => x.setReadonlyValueOverride(!this.editable));

    }, 0);
  }

  private setupActionButtonsState() {
    setTimeout(() => {
      this.buttons.forEach(x => {
        x.toggleDisplay(this.editable);
      });
    }, 0);
  }
}
